// extracted by mini-css-extract-plugin
export default {"modalBtn":"style_modalBtn__98rt1","modalImage":"style_modalImage__yFynr","progressBarContainer":"style_progressBarContainer__NkJ50","info":"style_info__VtWsa"};